// Filename: models/questionnaire/question.js
define('collections/stats/week-stats',[
    'underscore', 'backbone', 'utils',
    // src
    'services/api',
    // model
    'models/stats/week-stat'
], function(_, Backbone, U, API, MWeekStat) {

    var CWeekStats = Backbone.Collection.extend({
        model: MWeekStat,
        url: API.url('users/me/weekly-stats'),

        parse: function(data, opt) {
            data = this.parseStats(data);
            return CWeekStats.__super__.parse.call(this, data, opt);
        },

        parseStats: function(data) {
            var stats = [];

            _.each(data.totals, function(val, key) {
                stats.push({
                    name: key,
                    total: key === 'duration' ? Math.round(data.totals[key] / 60) * 60 : Math.round(data.totals[key]),
                    best: key === 'duration' ? Math.round(data.bests[key] / 60) * 60 : Math.round(data.bests[key]),
                    obest: key === 'duration' ? Math.round(data.obests[key] / 60) * 60 : Math.round(data.obests[key])
                });
            });
            return stats;
        },
    });

    // Return the model for the module
    return CWeekStats;
});

